<template>
  <div class="homepage">
  

    <div class="centered">

        <div v-for="item in items" class="col-md-3 col-xs-3" :key="item.id">
          <itemTpl :item="item" />
        </div>
              
        <div class="clr"></div>

    </div>
  </div>
</template>

<script>
import itemTpl from './item_tpl.vue'


export default {
  components: { itemTpl },
  data() {
    return {
      promoted: [],
      items: [],
        id: this.$route.params.id,

    };
  },
  methods: {
  },
  created() {

    var self = this;
    // categories
    this.api_call({ url: 'favorites', onComplete: function(data){
      self.items = data.data.data.items;
    }});
    
  }
}
</script>